const state = {
  // 获取摄像头链接
  urlMsg: '',
  blob:'',
  // 存放webSocket
  socket: null
}

const mutations = {
  // 获取新消息内容
  GET_NEW_MSG: (state, msg) => {
    state.urlMsg = msg
  },
  // 存放websocket
  SOCKET: (state, socket) => {
    state.socket = socket
  }
}

const actions = {
  // 开启websocket
  createSocket({ commit, state }, data) {
    const ws = new WebSocket(data)
   
    commit('SOCKET', ws)
  },
  listenForMessages({ state, commit }, that) {
    state.socket.onopen = () => {
    }
    state.socket.onmessage = event => {
      // console.log(event.data,"传输数据");
      this.blob = event.data
      that.$bus.$emit('getBlob',event.data)
 
    }
    state.socket.onclose = () => {
    }
  },
  // 关闭websocket
  closeSocket({ state, commit }) {
    if (state.socket) {
      state.socket.close()
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

